<div class="site-content px-6 py-6">

    <div class="container">
       
      
        <div class="content-checkout flex flex-column md:flex-row align-items-stretch justify-content-start mt-5">
            <div class="content-experience-checkout w-full md:w-8 md:mr-8 md:pr-8">
       
                <div
                    class="experience-checkout-form pb-5">
                   <div class="flex flex-column md:flex-row justify-content-between align-items-start md:align-items-center mb-4 gap-2">
                     <h2 class="mt-0 text-2xl">Dati dell'acquirente</h2>
                     <p-button 
                       label="Torna indietro" 
                       icon="pi pi-arrow-left" 
                       (onClick)="goBack()"
                       [text]="true"
                       severity="secondary">
                     </p-button>
                   </div>
                   <p-confirmDialog></p-confirmDialog>

                   <form [formGroup]="checkoutForm" (ngSubmit)="onSubmit()" class="p-fluid">
                    <!-- Sezione dati dell'acquirente -->
                    <div class="flex flex-column md:flex-row align-items-start mb-3 gap-2">
                      <div class="p-field md:mr-3 flex-auto w-full">
                        <p-floatLabel>
                          <input pInputText id="firstName" formControlName="firstName" />
                          <label for="firstName">Nome*</label>
                        </p-floatLabel>
                        <small class="p-error" *ngIf="checkoutForm.get('firstName')?.invalid && checkoutForm.get('firstName')?.touched">
                          Nome è obbligatorio
                        </small>
                      </div>
                      <div class="p-field flex-auto w-full">
                        <p-floatLabel>
                          <input pInputText id="lastName" formControlName="lastName" />
                          <label for="lastName">Cognome*</label>
                        </p-floatLabel>
                      </div>
                    </div>
        
                    <div class="flex flex-wrap align-items-start mb-3">
                      <div class="p-field flex-auto">
                        <p-floatLabel>
                          <input id="email" type="email" pInputText formControlName="email" />
                          <label for="email">Email*</label>
                        </p-floatLabel>
                      </div>
                    </div>
        
                    <div class="flex flex-wrap align-items-start mb-3">
                      <div class="p-field flex-auto">
                        <p-floatLabel>
                          <input id="confirmEmail" type="email" pInputText formControlName="confirmEmail" />
                          <label for="confirmEmail">Conferma Email*</label>
                        </p-floatLabel>
                      </div>
                    </div>
        
                    <div class="flex flex-column md:flex-row align-items-start mb-3 gap-2">
                      <div class="p-field flex-auto w-full md:w-3">
                        <p-floatLabel>
                          <p-dropdown 
                            id="phonePrefix" 
                            [options]="phonePrefixes" 
                            optionLabel="prefix" 
                            formControlName="phonePrefix" 
                            [filter]="true"
                            filterBy="searchText"
                            [showClear]="true"
                            placeholder="Select a Prefix">
                            <ng-template pTemplate="selectedItem">
                              <div class="flex align-items-center gap-2" *ngIf="checkoutForm.get('phonePrefix')!.value">
                                <img 
                                  src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                                  [class]="'flag flag-' + checkoutForm.get('phonePrefix')!.value.code.toLowerCase()"
                                  style="width: 18px" />
                                <div>{{ checkoutForm.get('phonePrefix')!.value.prefix }}</div>
                              </div>
                            </ng-template>
                            <ng-template let-prefix pTemplate="item">
                              <div class="flex align-items-center gap-2">
                                <img 
                                  src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                                  [class]="'flag flag-' + prefix.code.toLowerCase()" 
                                  style="width: 18px" />
                                <div>{{ prefix.prefix }} {{ prefix.name }}</div>
                              </div>
                            </ng-template>
                          </p-dropdown>
                          <label for="phonePrefix">Prefisso*</label>
                        </p-floatLabel>    
                      </div>
        
                      <div class="p-field flex-auto w-full md:w-7 md:ml-2">
                        <p-floatLabel>
                          <input id="phoneNumber" type="text" pInputText formControlName="phoneNumber" />
                          <label for="phoneNumber">Telefono*</label>
                        </p-floatLabel>
                      </div>
                    </div>
        
                    <div class="flex flex-column md:flex-row align-items-start mb-3 gap-2">
                      <div class="p-field md:mr-3 flex-auto w-full">
                        <p-floatLabel>      
                          <p-dropdown id="country" [options]="countries" optionLabel="name" formControlName="country" [filter]="true" filterBy="name"></p-dropdown>
                          <label for="country">Paese di Residenza*</label>
                        </p-floatLabel>
                      </div>
                      <div class="p-field flex-auto w-full">
                        <p-floatLabel>   
                          <p-calendar id="birthDate" formControlName="birthDate"></p-calendar>
                          <label for="birthDate">Data di Nascita*</label>
                        </p-floatLabel>
                      </div>
                    </div>
        
                    <p-divider type="solid" />
        
                    <!-- Sezione dati del beneficiario, visibile solo se isGift è true -->
                    <div *ngIf="!formData.isReservation">
                      <h2 class="mt-0 text-2xl">Dati del beneficiario</h2>
        
                      <div class="flex flex-column md:flex-row align-items-start mb-3 gap-2">
                        <div class="p-field md:mr-3 flex-auto w-full">
                          <p-floatLabel>
                            <input pInputText id="recipientFirstName" formControlName="recipientFirstName" />
                            <label for="recipientFirstName">Nome del Beneficiario*</label>
                          </p-floatLabel>
                        </div>
                        <div class="p-field flex-auto w-full">
                          <p-floatLabel>
                            <input pInputText id="recipientLastName" formControlName="recipientLastName" />
                            <label for="recipientLastName">Cognome del Beneficiario*</label>
                          </p-floatLabel>
                        </div>
                      </div>
        
<!-- Email Beneficiario -->
<div class="flex flex-wrap align-items-start mb-3">
    <div class="p-field flex-auto">
      <p-floatLabel>
        <input id="recipientEmail" type="email" pInputText formControlName="recipientEmail" />
        <label for="recipientEmail">Email del Beneficiario*</label>
      </p-floatLabel>
    </div>
  </div>
  
  <!-- Conferma Email Beneficiario -->
  <div class="flex flex-wrap align-items-start mb-3">
    <div class="p-field flex-auto">
      <p-floatLabel>
        <input id="confirmRecipientEmail" type="email" pInputText formControlName="confirmRecipientEmail" />
        <label for="confirmRecipientEmail">Conferma Email del Beneficiario*</label>
      </p-floatLabel>
    </div>
  </div>
  
  <!-- Errore di Mismatch Email -->
  <div *ngIf="checkoutForm.hasError('emailMismatch') && 
              checkoutForm.get('recipientEmail')?.touched && 
              checkoutForm.get('confirmRecipientEmail')?.touched">
    <p class="errorValidator">Email del beneficiario e conferma email non corrispondono.</p>
  </div>
        
                      <div class="flex flex-wrap align-items-start mb-3">
                        <div class="p-field flex-auto">
                          <p-floatLabel>
                            <p-calendar id="recipientNotificationDate" formControlName="recipientNotificationDate"></p-calendar>
                            <label for="recipientNotificationDate">Data di Notifica al Beneficiario*</label>
                          </p-floatLabel>
                          <p class="mt-4 mb-0">Nel giorno scelto per la notifica, il beneficiario riceverà il voucher con il link per riscattare il suo regalo e prenotare l’esperienza. Per gli Smart Tasting ti ricordiamo che il vino verrà spedito solamente dopo l’avvenuta prenotazione da parte del beneficiario del regalo. </p>
                        </div>
                      </div>

                      <p-divider type="solid" />

                      <h2 class="mt-0 text-2xl">Messaggio al Beneficiario</h2>
                    
                      <p-floatLabel>
                        <textarea id="messagge" rows="5" cols="30" pInputTextarea formControlName="recipientMessage"></textarea>
                        <label for="messagge">Scrivi qui il tuo messaggio per il beneficiario del regalo*</label>
                      </p-floatLabel>
          
        
                      <p-divider type="solid" />
                    </div>
                    <div  *ngIf="formData.isReservation" class="message-winery">
                    <h2 class="mt-0 text-2xl">Messaggio</h2>
                    
                    <p-floatLabel>
                      <textarea id="messagge" rows="5" cols="30" pInputTextarea formControlName="messagge"></textarea>
                      <label for="messagge">Scrivi qui il tuo messaggio*</label>
                    </p-floatLabel>
        
                    <p-divider type="solid" />

                    </div>
                    
                    <h2 class="mt-0 text-2xl">Hai un coupon?</h2>
                    
                    <p-floatLabel>
                      <input pInputText id="coupon" formControlName="coupon"/>
                      <label for="coupon">Inserisci coupon</label>
                    </p-floatLabel>
        
                    <p-divider type="solid" />
                   <div class="flex flex-column md:flex-row justify-content-between align-items-start md:align-items-center gap-2"> 
                    <h2 class="mt-0 text-2xl">Metodo di pagamento</h2>
                    <img class="w-2 h-full	" src="../../assets/images/Minimal-Credit-Card-Icons.png"/>
                    </div>
                    <div class="paymentMethods">

                    <!-- DWSPay payment -->
                    <div class="paymentDwspay" *ngIf="acceptDwspayPayment">
                      <div class="paymentDwspayLabel flex justify-content-start align-content-center">
                        <label>
                          Carta di credito
                        </label>
                      </div>
                      <div *ngIf="isDwspayActive && dwspayClientSecret && !isDwspayInitializing" class="my-4">
                        <app-dwspay [clientSecret]="dwspayClientSecret"></app-dwspay>
                      </div>
                      <div *ngIf="isDwspayActive && (isDwspayInitializing || !dwspayClientSecret)" class="my-4">
                        <p>Caricamento metodo di pagamento...</p>
                      </div>
                    </div>
                     <!-- Elemento di pagamento che mostra il modulo per il metodo di pagamento attivo -->
                    
                    </div>

                   

                    <div class="privacy my-4 ">
                      <div class="privacy-terms mb-2 cursor-pointer flex flex-wrap align-items-center">
                        <p-checkbox class="pr-3" binary="true" formControlName="privacyTerms" inputId="privacyTerms"></p-checkbox>
                        <label for="privacyTerms"> Dichiaro di aver letto e di accettare i <span class="font-bold">Termini e Condizioni generali</span> e i <span class="font-bold">Termini di Privacy</span></label>
                      </div>
                  
                      <div class="privacy-marketing mb-2 flex flex-wrap align-items-center">
                        <p-checkbox class="pr-3" binary="true" formControlName="privacyMarketing" inputId="privacyMarketing"></p-checkbox>
                        <label class="cursor-pointer" for="privacyMarketing">
                          Acconsento al trattamento per marketing diretto. 
                        </label>
                        <span class="text-sm font-bold toogle-button cursor-pointer" (click)="toggleExpand('marketing')">
                          {{ isPrivacyMarketingExpanded ? 'Nascondi' : 'Espandi' }}
                        </span>
                        <div *ngIf="isPrivacyMarketingExpanded" class="expanded-text text-sm my-2">
                          Acconsento a ricevere comunicazioni commerciali sui prodotti e/o servizi del titolare del trattamento
                          (a mezzo posta elettronica, cartacea, telefono, SMS, email ovvero sistemi automatizzati di comunicazione
                          a distanza specificamente indirizzati a determinate categorie di clienti).
                        </div>
                      </div>
                      
                      <div class="privacy-profiling flex flex-wrap align-items-center ">
                        <p-checkbox class="pr-3" binary="true" formControlName="privacyProfiling"  inputId="privacyProfiling"></p-checkbox>
                        <label class="cursor-pointer" for="privacyProfiling">
                          Profilazione per marketing diretto.   
                        </label>
                        <span class="text-sm font-bold toogle-button cursor-pointer" (click)="toggleExpand('profiling')">
                          {{ isPrivacyProfilingExpanded ? 'Nascondi' : 'Espandi' }}
                        </span>
                        <div *ngIf="isPrivacyProfilingExpanded" class="expanded-text text-sm my-2">
                          Acconsento al trattamento dei miei dati per scopi di profilazione finalizzata alla personalizzazione del marketing diretto e
                          alla pubblicità comportamentale.
                        </div>
                      </div>
                      
                    </div>
                    
      
                    
                    <div class="flex flex-wrap align-items-center justify-content-center mb-3">
                      <div class="p-col-12">
                        <button type="submit" class="btnCheckout" pButton label="Conferma e prenota" [disabled]="checkoutForm.invalid"></button>
                      </div>
                    </div>
                    <div *ngIf="isAvailabilityErrorVisible" class="error-message">
                      {{ availabilityErrorMessage || 'Si è verificato un errore. Riprova più tardi.' }}
                    </div>
                  </form>
                      <!-- Loading Overlay -->
      <app-loading-overlay
      [visible]="loading"
      [title]="loadingTitle"
      [message]="loadingMessage">
    </app-loading-overlay>

                </div>
              
               
            </div>
            <div class="content-experience-book w-full md:w-4 md:ml-8 mt-6 md:mt-0">
                <div class="inside-experience-book md:sticky z-5 shadow-4 border-round-2xl pt-5 px-4 pb-4 pb-2" style="top: 100px; max-height: calc(100vh - 120px);">
                    <div class="experience-price font-bold">
                      
                    </div>
                  

                    <div class="experience-booking-summary mt-3 relative">
                        
            
                          <div class="checkout-container" *ngIf="formData.isReservation">
                          <div class="checkout-header">
                            <h2 class="mb-0 mt-3">Stai prenotando:</h2>
                            <p class="experienceTitle font-bold	mt-0 mb-5">{{experience?.details?.title}}</p>
                            <img class="icon-header" src="../../assets/images/card-icon.png"/>
                          </div>
                            <p class="flex justify-content-between"><span>{{formData?.price01_label_with_count?.label || 'N/A'}} </span><span><strong>{{formData?.price01_label_with_count?.count || 0}}</strong></span></p>
                            
                            <p-divider />
                            <div *ngIf="formData?.experience_price_labels?.length > 0">
                                <div *ngFor="let person of formData.experience_price_labels">
                                  <ng-container *ngIf="person.count > 0">
                                    <p class="flex justify-content-between">
                                      <span>{{ person.priceTitle || person.priceDescription || 'Extra' }}</span>
                                      <span><strong>{{ person.count }}</strong></span>
                                    </p>
                                    <p-divider></p-divider>
                                  </ng-container>
                                </div>
                              </div>
                              
                                <p class="flex justify-content-between"><span>Data:</span><span><strong> {{ formData.date | date }}</strong></span></p>   
                            <p-divider /> 
                            <p *ngIf="hasTime()" class="flex justify-content-between">
                              <span>Ora:</span>
                              <span><strong>{{ getTimeValue() }}</strong></span>
                            </p>
                            <p-divider *ngIf="hasTime()" />
                            <div *ngIf="formData.extras">
                            <p  class="flex justify-content-between"><span>Extra: </span><span><strong> {{ formData.extras }}</strong></span></p>
                            <p-divider />
                            </div>
                            <!-- Altri dettagli del riepilogo, ad esempio il prezzo totale -->
                            <p class="flex justify-content-between"><span>Totale:</span><span><strong> {{ formatCurrencyCents(formData.totalPrice) }}</strong></span></p>
                          </div>

                          <div class="checkout-container" *ngIf="!formData.isReservation">
                            <div class="checkout-header">
                              <h2 class="mb-0 mt-3">Stai prenotando:</h2>
                              <p class="experienceTitle font-bold	mt-0 mb-5">{{experience?.details?.title}}</p>
                              <img class="icon-header" src="../../assets/images/gift-icon.png"/>
                            </div>
                            
                            <p class="flex justify-content-between"><span>{{formData?.price01_label_with_count?.label || 'N/A'}} </span><span><strong>{{formData?.price01_label_with_count?.count || 0}}</strong></span></p>
                            <p-divider />
                            <div *ngIf="formData?.experience_price_labels?.length > 0">
                                <div *ngFor="let person of formData.experience_price_labels">
                                  <ng-container *ngIf="person.count > 0">
                                    <p class="flex justify-content-between">
                                      <span>{{ person.priceTitle || person.priceDescription || 'Extra' }}</span>
                                      <span><strong>{{ person.count }}</strong></span>
                                    </p>
                                    <p-divider></p-divider>
                                  </ng-container>
                                </div>
                              </div>    
                        
                            <!-- Altri dettagli del riepilogo, ad esempio il prezzo totale -->
                            <p class="flex justify-content-between"><span>Totale:</span><span><strong> {{ formatCurrencyCents(formData.totalPrice) }}</strong></span></p>
                          </div>
                          

                    </div>
                </div>

            </div>
        </div>

    </div>
  </div>
  